import { stateFactoryKey, type StateFactory } from '@/injectionKeys';
import type { SEARCH_EXPERIENCES_MODAL_TAB_INDEX } from '@/utils/state';

type TabName = typeof SEARCH_EXPERIENCES_MODAL_TAB_INDEX;

/**
 * 現在選択中のタブインデックスを管理する Composable
 * 次にタブを含むコンポーネントを表示した際に、前回の選択状態を復元するためのもの
 */
export const useCurrentTabIndex = (tabName: TabName) => {
  const stateFactory = inject(stateFactoryKey) as StateFactory;
  const currentTabIndex = stateFactory.create<number>(tabName, 0);
  const updateTabIndex = (index: number) => {
    currentTabIndex.value = index;
  };

  return { currentTabIndex, updateTabIndex };
};
